import { Card, Grid, SegmentedControl, Text, Textarea } from '@mantine/core';
import { useState } from 'react';
import AiModelPromptParametersSettings from '../../AiModelPromptParametersSettings';
import AiModelSettings from '../../AiModelSettings';

const defaultAiPrompts = {
  productsPrompt: '',
};

const defaultAiPromptParameters = {
  emailPromptParameters: {},
  generalPromptParameters: {},
};

const SettingsTabAiPrompts = ({ domain, handleChange: handleChangeDomain }) => {
  const [aiPrompts, setAiPrompts] = useState(domain.aiPrompts || defaultAiPrompts);
  const [aiPromptParameters, setAiPromptParameters] = useState(domain?.aiPromptParameters || defaultAiPromptParameters);
  const [promptSettings, setPromptSettings] = useState();

  const handleChange = (event) => {
    setAiPrompts((prev) => {
      const newState = { ...prev, [event.name]: event.value };

      handleChangeDomain({ target: { name: 'aiPrompts', value: newState } });

      return newState;
    });
  };

  const handleParameterChange = (type, param, value) => {
    const currentParameters = { ...aiPromptParameters };
    currentParameters[type] = { ...currentParameters[type] };
    currentParameters[type][param] = value;
    setAiPromptParameters(currentParameters);

    handleChangeDomain({ target: { name: 'aiPromptParameters', value: currentParameters } });
  };

  const handleAiModelChange = (model) => {
    handleChangeDomain({ target: { name: 'aiModel', value: model } });
  };

  return (
    <Card withBorder>
      <Card.Section p="md">
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>AI Model</label>
          </Grid.Col>
          <AiModelSettings model={domain.aiModel} handleChange={handleAiModelChange} showInfoText={true} colSm={10} />
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }} style={{ display: 'flex', alignItems: 'center' }}>
            <label>AI Prompt Parameter Custom Settings</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <SegmentedControl
              value={promptSettings ?? ''}
              onChange={(value) => {
                setPromptSettings(value);
              }}
              data={[
                { label: 'Email Prompt Settings', value: 'emailPromptParameters' },
                { label: 'General Prompt Settings', value: 'generalPromptParameters' },
              ]}
            />
            <Text size="xs" c="dimmed" mt="xs">
              <strong>Email Prompt Settings</strong> will be applied to the prompt for email generation.{' '}
              <strong>General Prompt Settings</strong> will be applied to the prompts for profile and product
              generation.
            </Text>
          </Grid.Col>

          {promptSettings && (
            <Grid.Col span={12}>
              <AiModelPromptParametersSettings
                type={promptSettings}
                params={aiPromptParameters}
                handleParamChange={handleParameterChange}
                model={domain.aiModel}
              />
            </Grid.Col>
          )}
        </Grid>
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 2 }}>
            <label>Products Prompt*</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 10 }}>
            <Textarea
              style={{ width: '100%' }}
              rows={10}
              onChange={(e) => handleChange({ name: 'productsPrompt', value: e.target.value })}
              name="productsPrompt"
              value={aiPrompts.productsPrompt}
            />
            <Text size="xs" c="dimmed" mt="xs">
              This is the product Deep Ai Recommender predictions prompt.
            </Text>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default SettingsTabAiPrompts;
